import React from "react";
import "../CSS/styles.css";
import t1 from '../../assets/t1.png';
import t2 from '../../assets/t2.png';
import t3 from '../../assets/t3.png';
import t4 from '../../assets/t4.png';
import t5 from '../../assets/t5.png';
import t6 from '../../assets/t6.png';

const Team = () => {
  return (
    <div className="container-fluid px-lg-5 vbg py-5 mt-5 inter">
      <div className="row py-5 px-lg-5 justify-content-center">
        <h1 className="mb-0 bc fw-bold text-center">Our Team</h1>
        <p className="mb-0 mt-2 gc text-center">Meet the experts behind TAMBRO's success. Our diverse team brings together decades of <br /> experience across various domains. </p>
        <div className="col-lg-4 p-3 mt-5">
          <div className="container-or-table3 int2">
            <img src={t1} alt="" className="img-fluid px-0 mx-0" width="100%" />
            <div className="wcc p-4">
              <h5 className="mb-0 bc fw-bold">John Smith</h5>
              <p className="mb-0 mt-2 gc2 fw-medium">CEO & Founder</p>
              <p className="gc mb-0 mt-3 pb-4">John has over 20 years of experience in risk management and security consulting. </p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 p-3 mt-lg-5 mt-3">
          <div className="container-or-table3 int2">
            <img src={t2} alt="" className="img-fluid px-0 mx-0" width="100%" />
            <div className="wcc p-4">
              <h5 className="mb-0 bc fw-bold">Sarah Johnson</h5>
              <p className="mb-0 mt-2 gc2 fw-medium">Chief Operations Officer</p>
              <p className="gc mb-0 mt-3">Sarah leads our operations and ensures seamless delivery of services to clients worldwide.</p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 p-3 mt-lg-5 mt-3">
          <div className="container-or-table3 int2">
            <img src={t3} alt="" className="img-fluid px-0 mx-0" width="100%" />
            <div className="wcc p-4">
              <h5 className="mb-0 bc fw-bold">Michael Chen</h5>
              <p className="mb-0 mt-2 gc2 fw-medium">Chief Technology Officer</p>
              <p className="gc mb-0 mt-3 pb-4">Michael oversees our digital solutions and cyber security services.</p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 p-3 mt-lg-0 mt-3">
          <div className="container-or-table3 int2">
            <img src={t4} alt="" className="img-fluid px-0 mx-0" width="100%" />
            <div className="wcc p-4">
              <h5 className="mb-0 bc fw-bold">Amina Patel</h5>
              <p className="mb-0 mt-2 gc2 fw-medium">Director of Risk Management</p>
              <p className="gc mb-0 mt-3 pb-4">Amina is an expert in risk assessment and mitigation strategies.</p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 p-3 mt-lg-0 mt-3">
          <div className="container-or-table3 int2">
            <img src={t5} alt="" className="img-fluid px-0 mx-0" width="100%" />
            <div className="wcc p-4">
              <h5 className="mb-0 bc fw-bold">David Wilson</h5>
              <p className="mb-0 mt-2 gc2 fw-medium">Head of Crisis Management</p>
              <p className="gc mb-0 mt-3 pb-4">David specializes in crisis response planning and emergency management.</p>
            </div>
          </div>
        </div>
        <div className="col-lg-4 p-3 mt-lg-0 mt-3">
          <div className="container-or-table3 int2">
            <img src={t6} alt="" className="img-fluid px-0 mx-0" width="100%" />
            <div className="wcc p-4">
              <h5 className="mb-0 bc fw-bold">Elena Rodriguez</h5>
              <p className="mb-0 mt-2 gc2 fw-medium">Director of Training</p>
              <p className="gc mb-0 mt-3 pb-4">Elena leads our capacity building and training programs for clients. </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Team